import type { ReactElement } from "react";
import { EinheitFeld, SchalterFeld, WahlFeld, feldId } from "./felder.js";
import { mitWert, wertAn } from "../layoutEntwurf.js";
import type { PanelProps } from "../LayoutRegister.js";

/** Register „Sektionen": je Sektion des Katalogs die Grösse in pt (6..24) und der Schnitt;
 *  am Hinweis zusätzlich der Akzentbalken (Entscheid 26, `sektionen.hinweis.balken`). */
export function SektionenPanel(p: PanelProps): ReactElement {
  return (
    <div className="lay__panel">
      <p className="lay__panelhinweis">Schriftgrösse in Punkt (6 bis 24) und Schnitt je
        Abschnitt des Belegs.</p>
      {p.stand.katalog.sektionen.map((s) => {
        const pfad = `sektionen.${s.id}`;
        const fett = wertAn(p.entwurf, ["sektionen", s.id, "fett"]);
        return (
          <fieldset key={s.id} className="lay__gruppe">
            <legend>{s.label}</legend>
            <EinheitFeld id={feldId(`${pfad}.groesse`)} label={`${s.label}: Größe`}
              einheit="pt" wert={wertAn(p.entwurf, ["sektionen", s.id, "groesse"])}
              systemwert={s.groesse} fehler={p.feldFehler[`${pfad}.groesse`]}
              onWert={(neu) => p.onEntwurf(mitWert(p.entwurf, ["sektionen", s.id, "groesse"], neu))}
              onVerlassen={p.onFeldVerlassen} />
            <WahlFeld id={feldId(`${pfad}.fett`)} label={`${s.label}: Schnitt`}
              wert={typeof fett === "boolean" ? (fett ? "fett" : "normal") : ""}
              optionen={[
                { wert: "", text: `Systemwert (${s.fett ? "fett" : "normal"})` },
                { wert: "fett", text: "fett" },
                { wert: "normal", text: "normal" },
              ]}
              fehler={p.feldFehler[`${pfad}.fett`]}
              onWahl={(w) => {
                p.onEntwurf(mitWert(p.entwurf, ["sektionen", s.id, "fett"],
                  w === "" ? undefined : w === "fett"));
                p.onFeldVerlassen();
              }} />
            {s.balken !== undefined && (
              <SchalterFeld id={feldId(`${pfad}.balken`)} label="Akzentbalken am Hinweisblock"
                wert={wertAn(p.entwurf, ["sektionen", s.id, "balken"])} systemwert={s.balken}
                fehler={p.feldFehler[`${pfad}.balken`]}
                onWert={(neu) => {
                  p.onEntwurf(mitWert(p.entwurf, ["sektionen", s.id, "balken"], neu));
                  p.onFeldVerlassen();
                }} />
            )}
          </fieldset>
        );
      })}
    </div>
  );
}
